import React, { useState, useEffect, useCallback } from "react";
import apiUrl from "../../Apiurl";
import { useAuth0 } from "@auth0/auth0-react";
import ListaDashboard from "./pezziDB/ListaDashboard";
import BarraDashboard from "./BarraDashboard";

const FILTRI_INIZIALI = {
  dataInserimento: "",
  codVS: "",
  fonte: "",
  tipoSync: "",
  toSync: "",
  success: "",
  error: "",
  dataOperazione: "",
  utente: "",
};

function DBperDashboard({ setProductFunction, utente }) {
  const { user, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [includiMassive, setIncludiMassive] = useState(false);
  const [soloErrori, setSoloErrori] = useState(false);
  const [filtri, setFiltri] = useState(FILTRI_INIZIALI);
  const [filtriApplicati, setFiltriApplicati] = useState(FILTRI_INIZIALI);
  const [ordinamentoCampo, setOrdinamentoCampo] = useState("dataInserimento");
  const [ordinamentoDirezione, setOrdinamentoDirezione] = useState("desc");
  const [listaArticoli, setListaArticoli] = useState([]);
  const [pagina, setPagina] = useState(1);
  const [righePerPagina, setRighePerPagina] = useState(20);
  const [totaleRighe, setTotaleRighe] = useState(0);
  const [caricamento, setCaricamento] = useState(false);

  const caricaDashboard = useCallback(async () => {
    if (!token) {
      return;
    }

    setCaricamento(true);
    try {
      const params = new URLSearchParams({
        page: String(pagina),
        perPage: String(righePerPagina),
        errorsOnly: String(soloErrori),
        includeMassive: String(includiMassive),
        sortBy: ordinamentoCampo,
        sortDirection: ordinamentoDirezione,
        ...filtriApplicati,
      });
      const response = await fetch(
        `${apiUrl}/prodotti/ps/getDashboard?${params.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const result = await response.json();

      setListaArticoli(result.data || []);
      setTotaleRighe(result.total || 0);
    } finally {
      setCaricamento(false);
    }
  }, [
    token,
    pagina,
    righePerPagina,
    soloErrori,
    includiMassive,
    filtriApplicati,
    ordinamentoCampo,
    ordinamentoDirezione,
  ]);

  useEffect(() => {
    caricaDashboard();
  }, [caricaDashboard]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setPagina(1);
      setFiltriApplicati(filtri);
    }, 350);

    return () => window.clearTimeout(timer);
  }, [filtri]);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  const cambiaFiltroColonna = (nome, valore) => {
    setFiltri((filtriCorrenti) => ({
      ...filtriCorrenti,
      [nome]: valore,
    }));
  };

  const cambiaFiltroErrori = () => {
    setPagina(1);
    setSoloErrori((valoreCorrente) => !valoreCorrente);
  };

  const cambiaInclusioneMassive = () => {
    setPagina(1);
    setIncludiMassive((valoreCorrente) => !valoreCorrente);
  };

  const cambiaOrdinamento = (campo, direzione) => {
    setPagina(1);
    setOrdinamentoCampo(campo);
    setOrdinamentoDirezione(direzione === "asc" ? "asc" : "desc");
  };

  return (
    <div className="center">
      <div className="cf contentSubHeader flex">
        <div className="fl-ns w-100 pr1 pl1 sfondoBiancoTema">
          <BarraDashboard
            token={token}
            aggiorna={caricaDashboard}
            filtri={filtri}
            cambiaFiltroColonna={cambiaFiltroColonna}
            soloErrori={soloErrori}
            cambiaFiltroErrori={cambiaFiltroErrori}
            includiMassive={includiMassive}
            cambiaInclusioneMassive={cambiaInclusioneMassive}
          />
          <ListaDashboard
            key={`dashboard-${soloErrori}-${includiMassive}-${JSON.stringify(
              filtriApplicati,
            )}-${righePerPagina}`}
            setProductFunction={setProductFunction}
            listaArticoli={listaArticoli}
            utente={utente}
            token={token}
            aggiorna={caricaDashboard}
            pagina={pagina}
            righePerPagina={righePerPagina}
            totaleRighe={totaleRighe}
            caricamento={caricamento}
            ordinamentoCampo={ordinamentoCampo}
            ordinamentoDirezione={ordinamentoDirezione}
            cambiaOrdinamento={cambiaOrdinamento}
            cambiaPagina={setPagina}
            cambiaRighePerPagina={(nuovoValore) => {
              setRighePerPagina(nuovoValore);
              setPagina(1);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DBperDashboard;
